import type { IconData } from '@stacksjs/iconify-core'

export const fullscreenExit: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M204 181.372L38.628 16H16v22.628L181.372 204H44v32h192V44h-32zM326.628 304H464v-32H272v192h32V326.628L473.372 496H496v-22.628z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default fullscreenExit
